export default __webpack_public_path__ + "static/media/hi_mart_logo.334fc69d.png";